var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 23,
    viewBox: "0 0 6 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.842072 0.842066C-0.280682 1.96482 -0.280682 3.78517 0.842072 4.90793C1.96483 6.03068 3.78518 6.03068 4.90793 4.90793C6.03069 3.78517 6.03069 1.96482 4.90793 0.842066C3.78522 -0.280689 1.96487 -0.280689 0.842072 0.842066Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.842072 9.46707C-0.280682 10.5898 -0.280682 12.4102 0.842072 13.5329C1.96483 14.6557 3.78518 14.6557 4.90793 13.5329C6.03069 12.4102 6.03069 10.5898 4.90793 9.46707C3.78522 8.34431 1.96487 8.34431 0.842072 9.46707Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.842072 18.0921C-0.280682 19.2148 -0.280682 21.0352 0.842072 22.1579C1.96483 23.2807 3.78518 23.2807 4.90793 22.1579C6.03069 21.0352 6.03069 19.2148 4.90793 18.0921C3.78522 16.9693 1.96487 16.9693 0.842072 18.0921Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.2cd9ee2c3bcf39690c48894ec0b2d481.svg";
export { ForwardRef as ReactComponent };